import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import s from 'components/bolt/quizPhotobooth/loader.sss';

export default class Loader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loadingAnim: null,
		};
	}
	async componentDidMount() {
		if (!this.props.loadingAnimData) return;
		const { loading, loadingAnimData, isDesktopWidth } = this.props;
		const { loadingAnimDesktop, loadingAnimMobile } = loadingAnimData;
		const path = isDesktopWidth ? loadingAnimDesktop : loadingAnimMobile;
		if (!path?.endsWith('.json') || !this.$loadingAnimContainer) {
			// TODO: ability to use images as loaders
			return;
		}
		const lottie = await import('lottie-web');
		this.setState({
			loadingAnim: lottie.loadAnimation({
				container: this.$loadingAnimContainer,
				renderer: 'svg',
				loop: true,
				autoplay: !!loading,
				path,
			}),
		});
	}

	componentDidUpdate(prevProps) {
		if (this.props.loading && !prevProps.loading) {
			this.state.loadingAnim?.play();
		}
	}

	componentWillUnmount() {
		this.state.loadingAnim?.destroy();
	}

	renderTop() {}

	render({ loadingAnimData, appData, loading, progress }) {
		return loadingAnimData ? (
			<div
				class={joinClasses(s.loadingAnimContainer, this.props.loading && s.show)}
				ref={$ref => this.$loadingAnimContainer = $ref}
			/>
		) : (
			<div class={joinClasses(s.container, loading && s.show)}>
				{this.renderTop()}
				<div class={joinClasses(s.loadingBar, loading && s.loading)} style={`--progress: ${progress || 0};`} key="progress" />
				<p class={joinClasses(s.loadingText, appData?.styling?.fontVariables?.quizPhotoboothMessage)} key="text">
					{appData?.copy?.baseCopy?.$QUIZPHOTOBOOTH_PHOTOBOOTH_LOADING}
				</p>
			</div>
		);
	}
}